export interface SelectionEventDetail {
  type: string;
  id: number | string;
  target?: string;
  [key: string]: any;
}

export const SELECTION_EVENT = 'item:selected' as const;
export const SCOPE_ATTR = 'data-selection-scope' as const;

/**
 * Resolves the scope element for dispatching selection events.
 * Walks up the DOM from the given element looking for:
 * 1. An explicit CSS selector match (if scopeSelector is provided)
 * 2. The nearest [data-selection-scope] ancestor
 * 3. The nearest [data-controller="dialog"] ancestor (backward compat with media_selector)
 * 4. Falls back to document
 */
export function resolveScopeElement(
  element: Element,
  scopeSelector?: string
): Element | Document {
  if (scopeSelector) {
    const match = element.closest(scopeSelector);
    if (match) return match;
  }

  return element.closest(`[${SCOPE_ATTR}]`)
    || element.closest('[data-controller="dialog"]')
    || document;
}

/**
 * Dispatches an item:selected CustomEvent on the resolved scope element.
 * The event bubbles, so any ancestor (or document listener) can catch it.
 */
export function emitSelected(
  detail: SelectionEventDetail,
  from: Element,
  scopeSelector?: string
): void {
  const scope = resolveScopeElement(from, scopeSelector);
  scope.dispatchEvent(new CustomEvent(SELECTION_EVENT, {
    detail,
    bubbles: true,
  }));
}
